<template>
  <div class="GlobalFormDemo">
    <GlobalForm :init-data="initData" :form-item-list="formItemList" :inline="true" :labelWidth="80" round
      :needBtnLoading="true" @handleConfirm="handleConfirm" confirmBtnName="查询">
      <el-form-item class="el_from" label="服务商" slot="channel" style="margin:0" label-width="70px">
        <el-select v-model="channel" placeholder="请选择服务商查询" filterable clearable>
          <el-option v-for="item in channePullList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div slot="day">
        <div>
          <el-form-item v-if="state == 6" label="签收时间" style="margin-right:10px;">
            <el-date-picker v-model='signTime' type="daterange" start-placeholder="开始日期" range-separator="~"
              end-placeholder="结束日期" clearable :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="state == 7" label="取消时间" style="margin-right:10px;">
            <el-date-picker v-model='cancelTime' type="daterange" start-placeholder="开始日期" range-separator="~"
              end-placeholder="结束日期" clearable :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label-width="0">
            <span>下单后</span>
            <el-select v-model="day" clearable placeholder="选择天数" style="width:100px">
              <el-option v-for="item in signedDayList" :key="item" :label="item + '天'" :value="item" />
            </el-select>
            <span>未签收</span>
          </el-form-item>
        </div>
      </div>
      <div slot="AddSlot">
        <el-button size="small" :loading="isExportLoading" type="success" icon="el-icon-download"
          @click="clickExcel">导出Excel</el-button>
      </div>
    </GlobalForm>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { channePull, orderLogisticsDown } from "../../../utils/request/changePhone";
import moment from "moment";
export default {
  name: "Form",
  props: {
    tabIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      channePullList: [],
      state: 1,
      isExportLoading: false,
      day: "",
      seachParams: {},
      channel: '',
      signTime: null,
      cancelTime: null,
      initData: null,
      formItemList: [
        { slotName: "channel" },
        {
          key: "senderTel",
          type: "input",
          labelName: "营业员手机号",
          placeholder: "请输入手机号查询",
          labelWidth: "100px",
        },
        {
          key: "mailNumber",
          type: "input",
          labelName: "物流单号",
          placeholder: "请输入物流单号查询",
          labelWidth: "70px",
        },
        {
          key: "imei",
          type: "input",
          labelName: "串号",
          placeholder: "请输入串号查询",
          labelWidth: "50px",
        },
        {
          labelWidth: "54px",
          key: "entryTime",
          type: "daterange",
          labelName: "时间",
          placeholder: "请选择时间",
          valueFormat: "timestamp",
        },
        { slotName: "day" },
        {
          key: 'mold',
          idKey: 'value',
          labelKey: 'name',
          type: 'selectFilterable',
          labelName: '类型',
          option: [{
            value:1,
            name:'移动'
          },
          {
            value:2,
            name:'联通'
          }
        ],
          placeholder: '请选择商家名称'
        },
      ],
      signedDayList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },
  created() {
    this.getChannePull()
    this.handleConfirm();
  },
  watch: {
    tabIndex(val) {
      if (val == 0) {
        this.state = 1
      } else if (val == 1) {
        this.state = 2
      } else if (val == 2) {
        this.state = 6
      } else if (val == 3) {
        this.state = 7
      }
    },
  },
  methods: {
    getChannePull() {
      channePull().then((res) => {
        this.channePullList = res.data;
      });
    },

    clickExcel() {
      this.isExportLoading = true
      orderLogisticsDown(this.seachParams).then((res) => {
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "运单监控.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");

        this.isExportLoading = false
      }).catch(err => {
        this.isExportLoading = false
      });
    },
    handleConfirm(data, cd) {
      let SeachParams = {};
      if (data) {
        let beg_time = "";
        let end_time = "";
        if (!data.entryTime) {
          (beg_time = ""), (end_time = "");
        } else {
          (beg_time = moment(data.entryTime[0]).format("x")),
            (end_time = moment(data.entryTime[1]).format("x"));
        }
        let beg_signTime = "";
        let end_signTime = "";
        if (!this.signTime) {
          (beg_signTime = ""), (end_signTime = "");
        } else {
          (beg_signTime = moment(this.signTime[0]).format("x")),
            (end_signTime = moment(this.signTime[1]).format("x"));
        }

        let beg_cancelTime = "";
        let end_cancelTime = "";
        if (!this.cancelTime) {
          (beg_cancelTime = ""), (end_cancelTime = "");
        } else {
          (beg_cancelTime = moment(this.cancelTime[0]).format("x")),
            (end_cancelTime = moment(this.cancelTime[1]).format("x"));
        }

        SeachParams = {
          channel: this.channel,
          day: this.day,
          state: this.state,
          beg_time: beg_time,
          end_time: end_time,
          beg_signTime: beg_signTime,
          end_signTime: end_signTime,
          beg_cancelTime: beg_cancelTime,
          end_cancelTime: end_cancelTime,
          ...data,
          disuseLoding: () => {
            if (typeof cd === 'function') {
              cd()
            }
          },
        };
      }
      this.seachParams = SeachParams;
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {}
</style>
